import styled from 'styled-components';

interface ILabel {
  color?: string;
  fontSize?: string;
}

const Label = styled.label<ILabel>`
  color: ${({ color, theme }) => color ?? theme?.colors?.text1};
  font-size: ${({ fontSize }) => fontSize ?? '0.8rem'};
  position: relative;
`;

export default Label;
